const DEFAULT_VARIANT = 'A';
// NB: Currently configured to track this single experiment as a default
const GOOGLE_OPTIMIZE_EXPERIMENT_ID_EVENT_CARD_OPENS_NEW_TAB =
    'bZRKXAweQvuO9QlO5LR5mQ';
const NOOP = () => null;

/**
 *
 * @param {String} experimentName - the Experiment Id from Google Optimize
 * @param {Function} setVariantEnrollment - callback function invoked with variant
 */
export const enrollInOptimizeExperiment = ({
    experimentName = GOOGLE_OPTIMIZE_EXPERIMENT_ID_EVENT_CARD_OPENS_NEW_TAB,
    defaultVariant = null,
    setVariantEnrollment = NOOP,
}) => {
    if (window.gtag) {
        window.gtag('event', 'optimize.callback', {
            name: experimentName,
            callback: (value, name) => {
                let variant = defaultVariant || DEFAULT_VARIANT;
                // NB: Can add logic for specific experiements
                if (name === experimentName) {
                    if (value == '0') {
                        variant = 'A';
                    } else if (value == '1') {
                        variant = 'B';
                    } else if (value == '2') {
                        variant = 'C';
                    }

                    setVariantEnrollment(variant);
                } else {
                    // just to be extra safe
                    setVariantEnrollment(DEFAULT_VARIANT);
                }

                return variant;
            },
        });
    } else {
        // If no Optimize is available we still want to set to A for the default
        // experience if/when gtag loads it will be tracked.
        setVariantEnrollment('A');
    }
};

// NB: Developer shortcut to force Variation B
export const forceExperimentVariationB = () => {
    if (typeof window === 'object' && window.location) {
        return window.location.href.endsWith('#b');
    }

    return false;
};
